import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { ArtifactsDataProvider } from '@trovata/app/features/ai-artifacts/services/artifacts-data-provider';
import {
	ArtifactDataResponse,
	ArtifactSaveResult,
	ArtifactsResponse,
	DataArtifact,
	FilePreviewResponse,
	RecordDetailResponse,
} from '@trovata/app/features/ai-artifacts/models/artifacts.model';

/**
 * CashArtifactsDataProvider — the Cash target of the artifacts data seam.
 *
 * Data artifacts are TMS-only; Cash has no artifact backend. This provider returns empty/no-op
 * results so the router never reaches the TMS HTTP path on a Cash surface. Read calls resolve to
 * empty (an empty list / a never-found load); write calls are inert. This is the Cash-isolation
 * guarantee: the Cash path makes no `/api/v1/ai-artifact` request.
 */
@Injectable({ providedIn: 'root' })
export class CashArtifactsDataProvider implements ArtifactsDataProvider {
	listArtifacts(): Observable<ArtifactsResponse> {
		return of({ artifacts: [] });
	}

	loadArtifact(artifactId: string): Observable<DataArtifact> {
		return throwError(() => new Error(`Data artifacts are not available in the Cash context (artifactId=${artifactId}).`));
	}

	getArtifactData(): Observable<ArtifactDataResponse> {
		return of({
			records: [],
			columnMap: {},
			appFields: {},
			fieldTypes: {},
			primaryKeyFields: [],
			filterFields: {},
			effectiveFilters: [],
			pagination: null,
		});
	}

	saveArtifact(): Observable<ArtifactSaveResult> {
		return of({ artifactId: '', validation: null });
	}

	deleteArtifact(): Observable<void> {
		return of(undefined);
	}

	getRecordDetail(artifactId: string): Observable<RecordDetailResponse> {
		return throwError(() => new Error(`Data artifacts are not available in the Cash context (artifactId=${artifactId}).`));
	}

	fileDownload(fileId: string): Observable<HttpResponse<Blob>> {
		return throwError(() => new Error(`Data artifacts are not available in the Cash context (fileId=${fileId}).`));
	}

	filePreview(fileId: string): Observable<FilePreviewResponse> {
		return throwError(() => new Error(`Data artifacts are not available in the Cash context (fileId=${fileId}).`));
	}
}
